/**
 * @fileoverview Maps report option ids to export handlers.
 * @module pages/reports/reportDownloadDispatch
 */
import { REPORT_OPTION } from "../../utils/reportConstants.js";
import {
  downloadAuthenticationLogs,
  downloadBuyerLogs,
  downloadB2bEventAttendanceLogs,
  downloadInvoiceLogs,
  downloadGeneralReportOnBusinessEventsBuyerCompaniesAppointments,
  downloadBusinessEventAppointmentDetailsReport,
  downloadBusinessEventRequirementsReport,
  downloadAccumulatedEventsConnectionsReport,
  downloadEventsAttendancesReport,
  downloadSACReport,
  downloadGeneralB2BReport,
  downloadVirtualEventsRegistrationReport,
} from "./reportDownloads.js";

const REPORT_DOWNLOAD_HANDLERS = {
  [REPORT_OPTION.AUTHENTICATION_LOGS]: downloadAuthenticationLogs,
  [REPORT_OPTION.BUYER_LOGS]: downloadBuyerLogs,
  [REPORT_OPTION.B2B_ATTENDANCE]: downloadB2bEventAttendanceLogs,
  [REPORT_OPTION.MEMBER_INVOICE]: (ctx) =>
    downloadInvoiceLogs(ctx, "member"),
  [REPORT_OPTION.NON_MEMBER_INVOICE]: (ctx) =>
    downloadInvoiceLogs(ctx, "non-member"),
  [REPORT_OPTION.GENERAL_APPOINTMENTS]:
    downloadGeneralReportOnBusinessEventsBuyerCompaniesAppointments,
  [REPORT_OPTION.APPOINTMENT_DETAILS]:
    downloadBusinessEventAppointmentDetailsReport,
  [REPORT_OPTION.ACCUMULATED_CONNECTIONS]:
    downloadAccumulatedEventsConnectionsReport,
  [REPORT_OPTION.REQUIREMENTS]: downloadBusinessEventRequirementsReport,
  [REPORT_OPTION.EVENT_ATTENDANCES]: downloadEventsAttendancesReport,
  [REPORT_OPTION.SAC]: downloadSACReport,
  [REPORT_OPTION.GENERAL_B2B]: downloadGeneralB2BReport,
  [REPORT_OPTION.VIRTUAL_REGISTRATION]: downloadVirtualEventsRegistrationReport,
};

/** Runs the export handler for the currently selected report type. */
export const downloadReportByOption = async (optionValue, ctx) => {
  const handler = REPORT_DOWNLOAD_HANDLERS[optionValue];
  if (handler) {
    await handler(ctx);
  }
};
